export default __webpack_public_path__ + "static/media/cube.b30777a2.svg";